import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useInspMethodForm } from './hooks/useInspMethodForm';

const { TextArea } = Input;

const P111GForm: React.FC = () => {
  const f = useInspMethodForm();
  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!f.current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${f.current.f11g_01}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: f.doDelete,
    });
  };
  const modeLabel = f.mode === 'add' ? '新增' : f.mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={f.loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          驗貨方式設定 (pw111gf1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {f.records.length > 0 ? `${f.currentIdx + 1} / ${f.records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && f.quickSearch(searchText.trim())}
            disabled={f.isEditing} style={{ width: 150 }} maxLength={2} />
          <Button onClick={() => searchText.trim() && f.quickSearch(searchText.trim())} disabled={f.isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={f.navFirst} disabled={f.isEditing || !f.records.length}>|&lt;</Button>
          <Button size="small" onClick={f.navPrev} disabled={f.isEditing || f.currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={f.navNext} disabled={f.isEditing || f.currentIdx >= f.records.length - 1}>&gt;</Button>
          <Button size="small" onClick={f.navLast} disabled={f.isEditing || !f.records.length}>&gt;|</Button>
        </div>
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">驗貨方式代號 (F11G_01)</label>
            <Input value={f.code} onChange={e => f.setCode(e.target.value)} maxLength={2}
              disabled={f.mode !== 'add'} style={{ width: 100 }} placeholder="2碼" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">中文說明 (F11G_11)</label>
            <TextArea value={f.descCn} onChange={e => f.setDescCn(e.target.value)}
              disabled={!f.isEditing} rows={4} style={{ width: 500 }} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">英文說明 (F11G_12)</label>
            <TextArea value={f.descEn} onChange={e => f.setDescEn(e.target.value)}
              disabled={!f.isEditing} rows={4} style={{ width: 500 }} />
          </div>
        </div>
        {f.current && f.mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立者: {f.current.f11g_91} | 建立日期: {f.current.f11g_92 || '-'} | 修改者: {f.current.f11g_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!f.isEditing ? (
            <>
              <Button type="primary" onClick={f.startAdd}>新增</Button>
              <Button onClick={f.startEdit} disabled={!f.current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!f.current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={f.save}>儲存</Button>
              <Button onClick={f.cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P111GForm;
